<template>
  <div id="fristagency">
    <div class="fristagency-content">
      <div class="fristagency-banner">
        <img src="../../../static/images/fristagency-banner.jpg" alt="">
      </div>

      <div class="fristagency-main">

        <div class="fristagency-detail">
          
          <div class="fristagency-icon">
            <img src="../../../static/images/fristagency-icon1.png" alt="">
          </div>

          <div class="fristagency-kh" v-html="fristagency_kh"></div>

        </div>

      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import NavDom from '@/components/navtop/navloginbefore'
export default {
  name: 'Fristagency',
  data() {
    return {
      fristagency_kh:"你已经拥有一定数量的代理资源,可以联系我们渠道经理<br/>商谈成为平台一级代理，拥有更多的资源支持。"
    }
  },
  created () {
    /*this.getConpy();*/
  },
  methods: {
    
  },
  components: {
    NavDom
  }
}
</script>

<style lang="stylus" scoped>
  .fristagency-banner
    img
      width 100%

  .fristagency-main
    width 1080px
    margin 0 auto

    .fristagency-detail
      margin 0 auto
      width 764px

      .fristagency-icon
        text-align center
        margin 40px 0 0 0

      .fristagency-kh
        margin 40px 0
        font-size 30px
        color #000000
        text-align center
        line-height 60px

    
</style>


// WEBPACK FOOTER //
// src/components/service/fristagency.vue